//#region types
import { DimensionEnums } from "models/enums";
import { DimensionStepProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import {
  DimensionChipSelector,
  ExpandableSection,
  FormFieldLayout,
  ExpandableSectionSummary,
} from "components/common/wintForms";
//#endregion
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

const DimensionStep: React.FC<DimensionStepProps<IncomingInvoiceFormTypes.Todo>> = ({
  connect,
  isOptional,
  amount,
  expandableStepProps,
  fileViewer,
}) => {
  const dimensionFieldProps = connect("dimensions");

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Tags)}
          subText={
            isOptional ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Optional) : undefined
          }
        />
      }
      initiallyOpen={!isOptional}
      hasErrors={dimensionFieldProps.hasErrors}
      {...expandableStepProps}
    >
      <DimensionChipSelector
        {...dimensionFieldProps}
        type={DimensionEnums.DimensionCategory.IncomingInvoice}
        amount={amount}
        layout={<FormFieldLayout noOuterSpacing />}
        fileViewer={fileViewer}
      />
    </ExpandableSection>
  );
};

export default DimensionStep;
